export const LIST_PROJECT = 'LIST_PROJECT'
export const LIST_PROJECTS = 'LIST_PROJECTS'
export const ADD_PROJECT = 'ADD_PROJECT'
export const UPDATE_PROJECT = 'UPDATE_PROJECT'
export const LIST_PROJECT_FILES = 'LIST_PROJECT_FILES'
export const ADD_PROJECT_FILES = 'ADD_PROJECT_FILES'
export const GET_CATEGORIES = 'GET_CATEGORIES'
export const GET_FILES = 'GET_FILES'

/* EXPERIMENTAL DESIGN */

export const GET_EXPIRMENT = 'GET_EXPIRMENT'
export const ADD_EXPIRMENT = 'ADD_EXPIRMENT'
export const ADD_VARIABLE = 'ADD_VARIABLE'
export const REMOVE_VARIABLE = 'REMOVE_VARIABLE'
export const ADD_DIMENSION = 'ADD_DIMENSION'
export const UPDATE_DIMENSION = 'UPDATE_DIMENSION'
export const REMOVE_DIMENSION = 'REMOVE_DIMENSION'